import { WebQuoteFormData } from "components/WebQuoteModal/WebQuoteForm/WebQuoteForm";
import { v4 as uuidv4 } from "uuid";

type WebQuoteRequest = {
  id: string;
  trackingId: string;
  captchaSolution: string | undefined;
  auid: string;
  cruiseCode: string;
  customer: WebQuoteFormData;
};

type WebQuoteResponse =
  | {
      type: "success";
      status: "validated";
      isTest: boolean;
    }
  | {
      type: "error";
      errorCode: WebQuoteError;
    };

export type WebQuoteError =
  | "invalidEmail"
  | "invalidCaptcha"
  | "fatal"
  | "transient";

type WebQuoteErrorResponse = {
  errorCode: WebQuoteError;
  request: WebQuoteRequest;
};

export const sendWebQuote = async (
  url: string,
  quoteProcessId: string,
  captchaSolution: string | undefined,
  cruiseCode: string,
  formData: WebQuoteFormData,
  auid: string,
  trackingId: string
): Promise<WebQuoteResponse> => {
  const requestBody: WebQuoteRequest = {
    id: quoteProcessId,
    trackingId,
    captchaSolution,
    auid,
    cruiseCode,
    customer: formData
  };

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(requestBody)
  });

  if (!response.ok) {
    try {
      const body = JSON.parse(await response.text()) as WebQuoteErrorResponse;
      return {
        type: "error",
        errorCode: body.errorCode
      };
    } catch {
      return {
        type: "error",
        errorCode: "fatal"
      };
    }
  }

  return { ...(await response.json()), type: "success" } as WebQuoteResponse;
};

export const generateFormTrackingId = (): string => `${Date.now()}-${uuidv4()}`;
